// 第9张
const imgAll9 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642304547/a9.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642845367/c9.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642304547/a9.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642845367/c9.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725092257318/a9.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725092747776/b9.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725093141778/uk9.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725093605033/uk9.jpg',
    },
};
export const imgLocale9: any = {
    jp: imgAll9.JP,
    us: imgAll9.NA,
    ca: imgAll9.NA,
    br: imgAll9.NA,
    mx: imgAll9.NA,
    uk: imgAll9.UK,
    eu: imgAll9.EU,
    de: imgAll9.EU,
    fr: imgAll9.EU,
    it: imgAll9.EU,
    es: imgAll9.EU,
};
